// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerPopoverPopupElement, type PopoverPopupElement } from '@prosekit/web/popover';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes } from 'react';

/** Props for the {@link PopoverPopup} React component. */
export interface PopoverPopupProps {}

function PopoverPopupComponent(props: PopoverPopupProps, forwardedRef: ForwardedRef<PopoverPopupElement>) {
  registerPopoverPopupElement();

  const elementRef = useRef<PopoverPopupElement>(null);

  const { ...restProps } = props;

  const mergedRef = useCallback(
    (element: PopoverPopupElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-popover-popup', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-popover-popup` custom element. */
export const PopoverPopup: ForwardRefExoticComponent<PopoverPopupProps & HTMLAttributes<PopoverPopupElement> & RefAttributes<PopoverPopupElement>> = /* @__PURE__ */ forwardRef(PopoverPopupComponent);
